import pathToRegexp from 'path-to-regexp';

export const getDetailParams = (pathName?: string) => {
  const pagePathName = pathName || window?.location?.pathname || '';
  const [, project_name, work_item_type, work_item_id] =
    pathToRegexp('/:project/:type/detail/:id').exec(pagePathName) || [];
  return {
    project_name,
    work_item_type,
    work_item_id,
  };
};

// 在这个路由是不是工作项详情页，不要走工作项详情页的特殊逻辑
const specialCacheKey = ['chart', 'chartdatascope', 'chartdatascopeV2'];

export const isDetailPage = (pathName?: string) => {
  const { project_name, work_item_type, work_item_id } = getDetailParams(pathName);
  return (
    !!project_name &&
    !!work_item_type &&
    !!work_item_id &&
    !specialCacheKey.includes(work_item_type)
  );
};
